<template>
  <div id="app_aside" class="d-none d-md-flex flex-column bg-white shadow-sm">
    <div class="mx-auto mt-5" @mouseenter="show_add_profile_pic()" @mouseleave="hide_add_profile_pic()">
      <div v-if="current_user.profile_image">
        <img :src="current_user.profile_image" alt="user" width="100" height="100"
            class="rounded-circle border border-success p-1"
            style="border-width: 3px !important; border-color: #00bea5 !important;">
      </div>
      <div v-else-if="is_authenticated">
        <img src="@/assets/new/image/user_darker.jpeg" alt="user" width="100" height="100"
            class="rounded-circle border border-success p-1"
            v-if="add_profile_pic_on_hover"
            @click="$router.push({ path: '/pardakht-shakhsi' })"
            style="border-width: 3px !important; border-color: #00bea5 !important; cursor: pointer !important;">
        <img src="@/assets/new/image/user.jpg" alt="user" width="100" height="100"
            class="rounded-circle border border-success p-1"
            v-else
            style="border-width: 3px !important; border-color: #00bea5 !important;">
      </div>
      <div v-else>
        <img src="@/assets/new/image/user.jpg" alt="user" width="100" height="100"
            class="rounded-circle border border-success p-1"
            style="border-width: 3px !important; border-color: #FF8D8D !important;">
      </div>
      <div v-if="is_authenticated && !current_user.profile_image"
          id="add_profile_pic"
          class="h3"
          style="display: none;"
          title="افزودن عکس">
        <i class="fas fa-plus"
          @click="$router.push({ path: '/pardakht-shakhsi' })"
          style="cursor: pointer !important;">
        </i>
      </div>

    </div>

    <div  v-if="status == 'success'"
          class="zp-sidebar" style="
            height: 20px;
            line-height: 10px;
            background-color: #00bea5;
            padding:2% 3%;
            color: white;
            text-align: center;
            position: relative;
            margin:0 auto;
            border-radius: 50px;
            top:-10px;
      ">
      <span class="en_num">ID : {{current_user.id}}</span>
    </div>
    <h5 v-if="status == 'success'" class="text-dark text-center text-white-in-dark-mode">
      <span v-if="current_user.user_type == user_types.LEGAL">{{ current_user.com_name_fa }}</span>
      <span v-else>{{ current_user.first_name + ' ' + current_user.last_name }}</span>
    </h5>

    <hr class="sidebar_hr">

    <div class="mt-4" id="sidebar_menu">
      <ul class="list-unstyled">
        <!-- pos_visitor and manage -->
        <template v-if="$can('read','marketing')">
           <li v-for="(item, index) in menu_manage" :key="index" :class="item.url == $route.fullPath ? 'sidebar_active_item sidebar_item' : 'sidebar_item'" >
          <router-link :to="item.url" v-if="is_authenticated || !item.need_auth">
            <span v-html="item.icon"></span>
            <span class="pr-2">{{ item.title }}</span>
          </router-link>
          <span v-else style="cursor: not-allowed !important;">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#a0a0a0"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
            <span class="pr-2">{{ item.title }}</span>
          </span>
        </li>
        </template>
        <!-- basic user -->
       <template v-else>
         <li v-for="(item, index) in menu" :key="index" :class="item.url == $route.fullPath ? 'sidebar_active_item sidebar_item' : 'sidebar_item'" >
          <router-link :to="item.url" v-if="is_authenticated || !item.need_auth">
            <span v-html="item.icon"></span>
            <span class="pr-2">{{ item.title }}</span>
          </router-link>
          <span v-else style="cursor: not-allowed !important;">
            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24" fill="#a0a0a0"><g fill="none"><path d="M0 0h24v24H0V0z"/><path d="M0 0h24v24H0V0z" opacity=".87"/></g><path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"/></svg>
            <span class="pr-2">{{ item.title }}</span>
          </span>
        </li>
       </template>
      </ul>
    </div>
    <div class="mt-auto mx-3">
      <router-link to="/" :class="'btn btn-block btn-outline-secondary rounded-pill'">
          <span class="pr-2 text-secondary">بازگشت به پنل اصلی</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import aside_menu from "@/components/main/aside-marketing";
import aside_menu_manage from "@/components/main/aside-marketing-manage";
import { mapGetters } from "vuex";
import { userTypes } from '@/constants/userTypes'

export default {
  data() {
    return {
      user_types: userTypes,
      add_profile_pic_on_hover: false,
      menu: aside_menu,
      menu_manage: aside_menu_manage
    }
  },
  computed: {
    ...mapGetters('user', [
      'is_authenticated',
      'is_authenticated_pending',
      'current_user',
      'status'
    ]),
    shouldFlash() {
      return ((String(window.localStorage.getItem('support_page_visited')) !== '1') && (String(window.localStorage.getItem('is_first_page')) === '1'));
    },
  },
  methods: {
    show_add_profile_pic() {
      $('#add_profile_pic').fadeIn();
      this.add_profile_pic_on_hover = true;
    },
    hide_add_profile_pic() {
      $('#add_profile_pic').fadeOut();
      this.add_profile_pic_on_hover = false;
    }
  },
}
</script>

<style scoped>
#add_profile_pic {
  height: 1px;
  width: 60px;
  text-align: center;
  position: relative;
  margin: auto;
  border-radius: 10px;
  top: -50px;
  right: 0px;
  color: #00bea5;
}
</style>
